import { Component, NgZone, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MemberService } from 'src/app/core/services/member.service';
import { RouterLink } from '@angular/router';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { Location } from '@angular/common';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gerenciar-pagamento',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterLink, AppButtonComponent],
  templateUrl: './gerenciar-pagamento.component.html',
  styleUrl: './gerenciar-pagamento.component.scss'
})
export class GerenciarPagamentoComponent implements OnInit {

  labelColor = 'white';
  creditCardInfo: any;

  buttonOptions = {
    buttonText: 'Voltar',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px'
  };

  buttonAddCardOptions = {
    buttonText: 'Adicionar cartão',
    borderRadius: '30px',
    buttonSize: 'btn btn-sm py-2 px-5 btn-primary',
  };

  constructor(
    private memberService: MemberService,
    private location: Location,
    
  ) { }

  ngOnInit() {
    this.loadCreditCardInfo();
  }

  back() {
    this.location.back();
  }

  private loadCreditCardInfo() {
    const currentUser = localStorage.getItem('current-user');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      const memberId = parsedUser.id;
      this.memberService.getCardInfo(memberId).subscribe({
        next: (data) => {
          console.log('Dados do cartão recebidos:', data);
          if (data && data.cardId && data.canUseCard) {
            if (data.cardBrand && data.lastCardDigits) {
              // Cenário onde o cartão está completo
              data.cardBrand = this.mapCardBrand(data.cardBrand);
              this.creditCardInfo = data;
              this.updateButtonText(true);
            } else {
              // Cenário onde o cartão está desatualizado
              this.creditCardInfo = { ...data, isOutdated: true };
              this.updateButtonText(true, true); // Atualiza o botão para "Atualizar cartão"
            }
          } else {
            // Cenário onde não há cartão
            this.creditCardInfo = null;
            this.updateButtonText(false);
          }
        },
        error: (error) => {
          console.error('Erro ao carregar informações do cartão:', error);
          this.updateButtonText(false);
        }
      });
    } else {
      console.error('Usuário não encontrado no localStorage.');
      this.updateButtonText(false);
    }
  }
  
  private updateButtonText(hasCardInfo: boolean, isOutdated: boolean = false): void {
    this.buttonAddCardOptions = {
      ...this.buttonAddCardOptions,
      buttonText: hasCardInfo ? (isOutdated ? 'Atualizar cartão' : 'Trocar cartão') : 'Adicionar cartão'
    };
  }

  private mapCardBrand(cardBrand: string): string {
    const brandMapping: { [key: string]: string } = {
      mastercard: 'master',
      visa: 'visa',
      maestro: 'generic-card',
      dinersclub: 'generic-card',
      jcb: 'generic-card',
      americanexpress: 'generic-card',
      unknown: 'generic-card'
    };
  
    return brandMapping[cardBrand.toLowerCase()] || 'credit_card'; // Retorna o ícone padrão do Material Design
  }
}